import { HTTPError } from 'ky';
import { z } from 'zod';

import i18n from '@/lib/i18n';
import { fastApi } from '@/services/api';

const PATH = 'v1/customer/form/uk-fca';

export const FCA_QUESTIONNAIRE_ANSWERS = ['authorizedPerson', 'exemptPerson', 'ordinaryBusinessPerson', 'none'] as const;

export const fcaQuestionnaireAnswersSchema = z.object({
  selfCertification: z.enum(FCA_QUESTIONNAIRE_ANSWERS, {
    error: i18n.t('requiredField.error'),
  }),
});

export type FcaQuestionnaireAnswers = z.infer<typeof fcaQuestionnaireAnswersSchema>;

export const fcaQuestionnaireSchema = z.object({
  answers: fcaQuestionnaireAnswersSchema,
});

export type FcaQuestionnaire = z.infer<typeof fcaQuestionnaireSchema>;

type FcaQuestionnaireGetResponse = FcaQuestionnaire;

export type FcaQuestionnairePostRequestBody = FcaQuestionnaire;

export const getFcaQuestionnaire = async () => {
  return fastApi
    .get(PATH)
    .json<FcaQuestionnaireGetResponse>()
    .catch((error) => {
      if (error instanceof HTTPError && error.response.status === 404) return null;

      throw error;
    });
};

export const postFcaQuestionnaire = async (body: FcaQuestionnairePostRequestBody) => {
  await fastApi.post(PATH, {
    json: body,
  });
};
